const zh = {
	uploadSuccess: '上传成功',
	uploadTitle: '上传公司章程',
	sizeText: '支持JPG/PNG/PDF，每个文件不能超过5M',
	upload: '选择文件',
	cashAccount: '提现账户',
	currentzAccount: '分发账户',
	currentzAccountText: '您尚未申请分发账户',
	currentzAccountText1: '您已经申请了分发账户',
	descriptionOfWithdrawals: '虚拟账户提现操作指南',
	addbankAccount: '添加银行账户',
	applyforVirtualAccount: '申请虚拟账户',
	applyCurrentz: '申请分发账户',
	applyCurrentzTip: '分发账户为PingPong分发平台的多币种账户，可用于向供应商付款等非提现用途。点击“确认”即表示同意开立分发账户。',
	virtualName: '虚拟户账户名',
	defaultNameTip: '账户名称将同步至pingpong收款平台，起到对应关系，如不填写将使用系统默认名称',
	virtualCurrency: '虚拟户币种',
	currencyTip: '请选择在此虚拟账户下支持的币种，可多选。',
	addCurrency: '添加币种',
	delete: '删除提现账户',
	deleteAccountTip: '您当前账户有打款中的款项将打入，若删除此账户，款项将打入原账户',
	deleteSureTip: '确定要删除此提现账户吗？',
	association: '若需开立EUR/GBP/PLN币种下的虚拟户，请先上传公司章程',
	return: '返回',
	buttonDelete: '删除',
	cancel: '取消',
	goInput: '上传',
	inReview: '审核中',
	reviewFailed: '审核失败',
	reviewPending: '审核中',
	modifyBank: '修改银行账户',
	accountInfo: '账户信息',
	comfirm: '确认',
	currency: '账户币种',
	bankName: '银行名称',
	cardNo: '银行卡号',
	iban: 'IBAN',
	swiftCode: 'swift代码',
	bankCode: '银行代码',
	bankCountry: '银行所在国家地区',
	reservedPhoneNo: '联系人号码',
	virtualAccountName: '打款账户',
	virtualSuccess: '虚拟账户创建成功！',
	exceed: '虚拟账户数量不能超过网站数量',
	created: '虚拟账户创建成功',
	atleast: '请选择至少一个币种',
	awd: {
		warmTips: '温馨提示',
		notSet: '未选择提现账户',
		toSet: '前往设置',
		skipSet: '暂不设置, 该币种将无法自动提现',
		autoWithdrawal: '自动提现功能',
		autoWithdrawalSet: '自动提现设置',
		topTip: '当您开启了自动提现功能，我们将在您指定的时间，自动对账户内所有可提现金额发起提现申请。',
		periodicity: '自动提现周期',
		minAmount: '起提金额',
		setMinAmount: '设置最小起提金额',
		limitAmount: '起提金额需大于100美元',
		setMinTips: '设置起提金额后，当账户内金额大于等于该金额后，将在“自动提现周期”发起自动提现。若账户币种非美元，将折合为美元后与起提金额进行比较。起提金额设置将应用于所有账户。',
		enabled: '已启用',
		unenabled: '未启用',
		unconfigured: '未配置',
		detail: '详情',
		set: '设置',
		currency: '币种',
		withdrawalTo: '自动提现至',
		warnTitle: '自动提现须知',
		confirmSet: '已知悉',
		edit: '编辑自动提现设置',
		save: '保存设置',
		cancel: '取消修改',
		agree: '我已阅读并同意',
		pleaseRead: '请阅读并同意以上须知',
		close: '自动提现停用理由：',
		modifyAccountTip: '此账户已被设置自动提现，修改此账户将导致对应币种无法自动提现。',
		deleteAccountTip: '此账户已被设置自动提现，删除此账户将导致对应币种无法自动提现。',
		tips: [
			['1. 您承诺在申请及使用PingPong Checkout自动提现服务的过程中，应及时向我们提供我们所需的一切相关资料，且您对提供的资料准确性、合法性、真实性、完整性及有效性承担全部责任；否则，您须承担由此给PingPong造成的全部损失。'],
			['2. 自动提现服务规则：', [
				'(1)	您可通过商户后台-账户中心-提现账户开通自动提现服务，开通后，PingPong会按照您设置的规则发起自动提现流程。',
				'(2)	自动提现服务仅支持总净值全额提现。若您PingPong Checkout账户某币种下单个GROUP账户资金存在负值，则将提出该币种下总净值或PingPong Checkout账户总净值（以二者孰低为准）。资金提现顺序将按照GROUP账户在您商户后台的排列顺序，自上而下提出。',
				'(3)	若您的可提现金额小于相应的自动提现服务手续费，将不会触发自动提现。',
				'(4)	设置起提金额后，当账户内金额大于等于该金额后，将在“自动提现周期”发起自动提现。若账户币种非美元，将折合为美元后与起提金额进行比较。起提金额设置将应用于所有账户。',
				'(5)	自动提现触发时间为工作日的0:00 UTC+0（即北京时间8：00），具体触发时间取决于您设置的自动提现服务频率。若遇欧洲卢森堡或中国节假日，将延至节假日后的第一个工作日处理。',
				'(6)	自动提现触发后，PingPong将根据内部合规政策及风险管理要求对自动提现申请进行审核。如您的自动提现申请不符合PingPong合规政策或风险管理要求，PingPong有权驳回您的自动提现申请。',
				'(7)	如连续14个自然日内，您的自动提现申请被驳回次数大于3次（含3次），PingPong将自动关闭您的自动提现功能。关闭后，您可重新设置并开启自动提现功能。',
				'(8)	PingPong有权对您的PingPong Checkout账户交易及相关操作进行审核，如果发现交易或操作存在风险，PingPong有权关闭您的自动提现功能。此情形下，您将无权重新开启自动提现功能。'
			]],
			['3. PingPong Checkout自动提现服务手续费将按照币种收费，具体收费规则以PingPong与您另行约定的规则为准。'],
			['4. 您开通自动提现服务后，如您希望停止使用该服务，请您及时在商户后台-账户中心-提现账户操作关闭自动提现服务。'],
			['5. 我们不对以下原因导致的自动提现服务延迟、中断或提现失败等承担任何责任：（i）因您的原因（包括但不限于您提供的信息不准确，您未提供提现账户，您提供的提现账户拒绝入账等）;(ii)第三方原因（包括但不限于第三方系统故障、政策变动等）; (iii) 网络故障、不可抗力等因素。'],
			['6. 在您确认开通PingPong Checkout自动提现服务后，即代表您同意授权我们（i）获得并使用您向我们提供的的全部信息，并同意授权我们（ii）向服务提供商提供必要的信息（包括但不限于提现账户）以促成本自动提现服务。'],
			['7. 您通过网络页面点击确认，即表示您同意接受本须知的所有条款及条件以及与本须知有关的已经发布或者将来可能发布的各项规则、页面展示、操作流程、公告或通知（以下合称“规则”），且PingPong有权利随时修改本须知和规则的内容并立即生效。若您在本须知变更后仍继续使用PingPong Checkout自动提现服务，即视作您同意此类变更。若您不同意上述条款，则不得申请或继续使用PingPong Checkout自动提现。']
		]
	},
	accountCenter: {
		bankAccountName: '收款人账户名',
		accountCenterTitle: '账号中心',
		clientId: '客户号',
		accountInformation: '账号信息',
		emailAddress: '邮箱地址',
		phoneNumber: '手机号码',
		identityVerification: '实名认证',
		remittanceAccount: '打款账户',
		accountOpenArea: '开户行地址',
		select: '请选择',
		selectShort: '请选择',
		hongkong: '中国香港',
		mainLand: '中国内地',
		europe: '欧洲',
		america: '美国',
		singapore: '新加坡',
		korea: '韩国',
		japan: '日本',
		uk: '英国',
		usd: '美元',
		rmb: '人民币',
		eur: '欧元',
		gbp: '英镑',
		aud: '澳元',
		hkd: '港币',
		krw: '韩元',
		sgd: '新加坡币',
		cnh: '离岸人民币',
		jpy: '日元',
		cad: '加拿大元',
		sek: '瑞典克朗',
		nok: '挪威克朗',
		accountCurrency: '账号币种',
		companyLegalName: '企业名称',
		companyLegalNameInEnglish: '企业英文名称',
		bankName: '银行名称',
		bankAccountNumber: '银行卡号',
		iban: 'IBAN',
		swiftCode: 'Swift代码',
		searchSwiftCode: '查询Swift Code',
		bankBranchName: '支行名称',
		bankCode: '银行代码',
		bankCountry: '银行所在国家/地区',
		bankBranchAddress: '开户支行地址',
		bankBranchDetailAddress: '支行具体地址',
		phoneNumber2: '联系人号码',
		bankAccountEmail: '收款人邮箱',
		shortCardNo: 'Sort Code',
		bankAccountCertificate: '银行开户证明',
		isVa: '是否为PingPong收款虚拟账户',
		yes: '是',
		no: '否',
		registeredPhoneNumber: '绑定手机号',
		verificationCode: '安全验证码',
		getaVerificationCode: '获取验证码',
		confirm: '确认添加账户',
		cancel: '取消',
		comfirmbtn: '确定',
		resendAfter30s: '后可重新发送',
		pleaseSelectAccountOpenArea: '请选择银行卡开户地区',
		pleaseSelectAccounturrency: '请选择开户币种',
		pleaseEntrySortCode: '请填写 Sort Code',
		pleaseEnterBankName: '请填写银行名称',
		pleaseEnterBankAccountNumber: '请填写银行卡号',
		pleaseEnterRightBankAccountNumber: '银行卡号只允许填入英文字母和数字',
		pleaseEnterIban: '请填写IBAN',
		pleaseEnterRightIban: 'IBAN只允许填入英文字母和数字',
		pleaseEnterSwiftCode: '请填写Swift Code 代码',
		swiftCodeInvalid: '请输入8位或者11位大写英文或者数字，不能包含空格',
		pleaseEnterBankBranchName: '请填写支行名称',
		pleaseEnterAbaRoutingNumber: '请填写 ACH Routing Number',

		pleaseEnterBankCode: '请填写银行代码',
		pleaseEnter3DigitsCode: '请填写3位数字',
		pleaseEnterBankBranchAddress: '请填写支行具体地址',
		pleaseEnterVerificationCode: '请输入验证码',
		errorVerificaitonCode: '验证码错误',
		invalidVerificationCode: '验证码失效',
		accountAlreadyExists: '收益账号已经存在',
		successSubmit: '添加收益账号成功',
		bankChineseName: '请输入中文银行名称',
		bankbranchChineseName: '请输入支行中文名称',
		bankbranchAddressChineseName: '请输入支行中文地址',
		bankEnName: '请输入英文银行名称',
		bankbranchEnName: '请输入英文支行名称',
		bankbranchAddressEnName: '请输入支行英文地址',
		pleaseEnterBankCountry: '请出入银行所在国家/地区',
		pleaseEnterBankOpen: '请输入银行开户证明',
		pleaseEnterBankAccountEmail: '请输入收款人邮箱',
		illegalBankAccountEmail: '请输入正确的收款人邮箱'

	},
	remittance: {
		remittanceAccount: '打款账户',
		modifyAccountInfo: '修改账户信息',
		failed1st: '打款账户信息审核未通过，',
		failed2nd: '，请修改后重新提交审核，如有疑问，请',
		failed3rd: '联系客服',
		failedTips: '打款账户审核未通过，请尽快联系客服，以免影响您的资金流转。',
		pending: '您的打款账户信息正在审核中，审核通过后，您可以发起提现了。',
		pending2nd: '您的打款账户正在审核中，审核通过后，我们将开始为您自动打款。',
		modalTipsWarn1: '您当前账户有',
		modalTipsWarn2: '打款中的款项',
		modalTipsWarn3: '将打入您的原账户,若您希望这些款项打入新的打款账户,请联系客服',
		confirm: '确认'
	},
	vaState: {
		normal: '',
		exceed: '虚拟账户数量不能超过网站数量',
		warn: '虚拟账户申请数已达上限，新申请的虚拟账户暂不支持在PingPong收款进行在岸人民币结汇。是否需要继续创建？'
	},
	warningTip: '注意',
	contact: '联系我们',
	editAccount: '修改账户信息'

}

export default zh
